import { loadLottieScript } from '../../utils/scripts';

document.addEventListener('alpine:init', () => {
  Alpine.data('homeHero', () => ({
    init() {
      this.$nextTick(() => {
        loadLottieScript().then(() => {
          bodymovin.loadAnimation({
            container: this.$refs.lottie,
            path: this.$refs.lottie.dataset.lottie,
            assetsPath: `${this.$refs.lottie.dataset.lottie.replace('/lottie.json', '')}/images2/`,
            renderer: 'svg',
            autoplay: true,
            loop: !!+this.$root.dataset.loop,
            rendererSettings: {
              filterSize: {
                width: '200%',
                height: '200%',
                x: '-50%',
                y: '-50%',
              },
            },
          });
        });
      });
    },
  }));
});